import { Padrao } from "../generic/padrao";

export class FormaEnvio extends Padrao{

    override idTab = 231;

    nome: string;
}